import { PublicClientApplication } from '@azure/msal-browser';

// Auth mode helpers
export const getAuthMode = () => window.__config__?.AUTH_MODE || 'impersonation';
export const isEntraAuth = () => getAuthMode() === 'entra';

// Read config from runtime config
const clientId = window.__config__?.AZURE_CLIENT_ID || '';
const tenantId = window.__config__?.AZURE_TENANT_ID || '';

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${clientId}/access_as_user`,
  ],
};

// Only create MSAL instance if clientId is configured AND auth mode is entra
let msalInstance = null;
if (clientId && isEntraAuth()) {
  msalInstance = new PublicClientApplication(msalConfig);
}

export { msalInstance };
